// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".footer .logo-div{width:50px;height:50px}.footer li{list-style-type:none}.footer .diasable{cursor:not-allowed}\n", "",{"version":3,"sources":["/app/src/component/common/footer/footer.scss"],"names":[],"mappings":"AAAA,kBAEI,UAAW,CACX,WAAY,CAHhB,WAMI,oBAAqB,CANzB,kBASI,kBAAmB","file":"footer.scss","sourcesContent":[".footer {\n  .logo-div {\n    width: 50px;\n    height: 50px;\n  }\n  li {\n    list-style-type: none;\n  }\n  .diasable {\n    cursor: not-allowed;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
